/* TGG phone buy flow (2026-09-12). See snippets/tgg-buy-flow.liquid. */
(function () {
  var form = document.querySelector('.tgg-pdp .product-form');
  var btn = form && form.querySelector('[data-cart-submit]');
  if (!btn) return;

  var TOGGLE = 'ajax-cart__toggle';               /* theme class: button is in "View cart" state */
  var TRANSITIONED = 'btn--to-secondary-transitioned';
  var note = form.querySelector('[data-cart-notification]');
  var offer = document.querySelector('[data-tgg-offer]');
  var addOne = offer && offer.querySelector('[data-tgg-add-one]');
  var bar = document.querySelector('[data-tgg-sticky-atc]');
  var barBtn = bar && bar.querySelector('[data-tgg-sticky-btn]');
  var barLabel = bar && bar.querySelector('[data-tgg-sticky-label]');

  /* ---------- Offer line ---------- */
  if (offer) (note || btn).insertAdjacentElement('afterend', offer);

  if (addOne) {
    addOne.addEventListener('click', function () {
      var qty = form.querySelector('input[name="quantity"]');
      var prev = qty ? qty.value : null;
      /* Put the theme button back in its Add to Cart state so the theme
         handles this add (cart drawer + cart count stay in sync). */
      btn.classList.remove(TOGGLE, TRANSITIONED);
      var primary = btn.querySelector('[data-cart-primary-submit-text]');
      var secondary = btn.querySelector('[data-cart-secondary-submit-text]');
      if (primary) primary.setAttribute('aria-hidden', 'false');
      if (secondary) secondary.setAttribute('aria-hidden', 'true');
      if (qty) qty.value = 1;
      btn.click();
      if (qty) qty.value = prev;
    });
  }

  /* ---------- Sticky bar ---------- */
  var phone = window.matchMedia('(max-width: 749px)');
  var pastButton = false;
  var footerInView = false;

  function render() {
    if (!bar) return;
    bar.classList.toggle('is-visible', phone.matches && pastButton && !footerInView);
  }

  function sync() {
    if (btn.classList.contains(TOGGLE) && offer) offer.hidden = false;
    if (!barBtn) return;
    barLabel.textContent = btn.getAttribute('aria-label') || barLabel.textContent;
    barBtn.disabled = btn.disabled;
  }

  if (bar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[entries.length - 1];
      pastButton = !e.isIntersecting && e.boundingClientRect.top < 0;
      render();
    }).observe(btn);

    var footer = document.querySelector('.site-footer');
    if (footer) {
      new IntersectionObserver(function (entries) {
        footerInView = entries[entries.length - 1].isIntersecting;
        render();
      }).observe(footer);
    }

    if (phone.addEventListener) phone.addEventListener('change', render);
    else if (phone.addListener) phone.addListener(render);

    barBtn.addEventListener('click', function () { btn.click(); });
  }

  new MutationObserver(sync).observe(btn, { attributes: true, attributeFilter: ['class', 'aria-label', 'disabled'] });
  sync();
})();
